import React from 'react'

const Vendors = () => {
  return (
    <div className='mx-auto p-4'>
      Vendor
    </div>
  )
}

export default Vendors
